import {css, StyleSheet} from 'aphrodite';
import React, {useState} from 'react';

import FormInput from 'ui-library/bs/FormInput';
import {InputChangeEvent} from 'util/Types';

export interface UserAgentGuidelinesProps {
  value: string;
  onSave: (newValue: string) => Promise<void>;
}

export default function UserAgentGuidelines({value, onSave}: UserAgentGuidelinesProps): JSX.Element {
  const [tempValue, setTempValue] = useState<string>(value);

  const handleSaveValue = async (newValue: string): Promise<void> => {
    await onSave(newValue);
  };

  return (
    <div className={css(styles.container)}>
      <FormInput
        type="textarea"
        value={tempValue}
        onChange={(e: InputChangeEvent) => {
          setTempValue(e.target.value);
        }}
        onBlur={() => {
          if (tempValue !== value) {
            handleSaveValue(tempValue);
          }
        }}
        placeholder="Description of your role, preferences, or specific instructions to keep in mind."
        rows={5}
        focusOnMount={false}
        selectAllOnClick={false}
        className={css(styles.textarea)}
      />
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    maxWidth: '400px',
  },
  textarea: {
    resize: 'vertical',
  },
});
